import SelectAjax from '@c/SelectAjaxComponent/component/SelectAjax.vue'

export default (app) => {
  app.component('SelectAjax', SelectAjax)
}
